<div
  fxLayout="row"
  class="header layout-unsecure"
  data-test-id="hdContainer"
  *ngIf="isLayoutEnabled"
>
  <div
    fxFlex="40%"
    fxLayoutAlign="start center"
    data-test-id="hdLogoContainer"
    class="logo-container"
  >
    <cigna-header-logo
      class="layoutUnsecureNonSigninLogo"
      [enableToggleSidNav]="true"
      [isFromLogin]="true"
      [attr.data-test-id]="'hdLogoConmponent'"
    ></cigna-header-logo>
  </div>
  <div fxFlex="28%" fxLayoutAlign="end center" class="contact-us-link">
    <cigna-caheader-unsecure></cigna-caheader-unsecure>
  </div>
</div>

<div class="imp-main-section-wrapper">
  <router-outlet></router-outlet>
</div>

<cigna-cafooter-unsecure
  *ngIf="!isSiteDown && isLayoutEnabled"
></cigna-cafooter-unsecure>
